export default "__VITE_ASSET__ClZAjOi___"